import React from "react";
import styled from "styled-components";
import { Section } from "./styles/formatting";
import {RESULT} from "../constants"

import { ButtonClear } from "./buttons";

const PathWrapper = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px;
`;

const Term = styled.div`
  color: white;
  font-size: 16px;
  padding: 8px;
  width: 176px;
`;

const Value = styled.div`
  color: white;
  font-size: 16px;
  padding: 8px;
`;
const Row = styled.div`
  border-bottom: 1px solid rgba(54, 64, 75, 0.33);
  display: flex;
`;

const id = Math.random();

const Result = ({ clear, dialectic, setViewDesciption, stage }) => {
  if (stage !== RESULT) return null;

  const handleViewDescription = () => {
    setViewDesciption(true);
    clear();
  };

  return (
    <Section>
      <PathWrapper>
        {Object.keys(dialectic).map((key, i) => (
          <Row key={`row-${id}-${i}`}>
            <Term>{`${key.toUpperCase()}: `}</Term>
            <Value>{dialectic[key].toUpperCase()}</Value>
          </Row>
        ))}
      </PathWrapper>
      <ButtonClear onClick={clear}>Start Over</ButtonClear>
      <button onClick={handleViewDescription}>About</button>
    </Section>
  );
};

export default Result;
